module.exports = __webpack_public_path__ + "static/media/USA-Purdue.efa5158c.png";